export const copyText = (text: string) => {
  navigator.clipboard.writeText(text)
}
